<template>
  <section >
  <el-form :model="loginForm" :rules="rules2" ref="loginForm" label-position="left" label-width="0px" class="login-container">
    <h3 class="title">宜春邮政快递业安全监管系统</h3>
    <el-form-item prop="loginName">
      <el-input type="text" v-model="loginForm.loginName" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleLogin" :loading="logining">登录</el-button>
    </el-form-item>
  </el-form>

    <div id="myfoot">
      <!-- 国家邮政局寄递安全技术研发中心<br>
      江西位服信息科技有限公司<br>
      联合研发<br> -->
      ©2026 宜春市邮政管理局 版权所有<br>
      <a href="http://beian.miit.gov.cn" target="_blank" style="color: #333">赣ICP备2026000945号-1</a>
    </div>
  </section>

</template>

<script>
  import {mgrlogin } from '../api/api';

  export default {
    data() {
      return {
        //登录数据
        logining: false,
        loginForm: {
          loginName: '',
          password: ''
        },
        rules2: {
          loginName: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        },

      };
    },
    methods: {
      // 点击登录
      handleLogin(ev) {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.logining = true;
            let para = {
              loginName: this.loginForm.loginName,
              password:this.loginForm.password
            };

            mgrlogin(para).then(res => {
              this.logining = false;
              if (res.data.code == 0) {
                  this.$message.success("登录成功");
                  let responsedata = res.data
                  //保存登录数据
                  sessionStorage.setItem('user', JSON.stringify(responsedata));
                  this.$router.push({ path: '/enterprise' });
              } else {
                this.$message.error(res.data.message);
              }
            });

          } else {
            return false;
          }
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
   
  }

  #myfoot {
    height: 100px;
    line-height: 20px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #333;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
  }

</style>


// WEBPACK FOOTER //
// Login.vue?6a7f93e2